import React, { useState } from 'react';
import { Button, Dropdown, MenuProps, message } from 'antd';
import { DownloadOutlined, FileExcelOutlined, FileTextOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import axios from 'axios';
import { config } from '../../config/env';

interface ExportMenuProps {
  days?: number;
}

export const ExportMenu: React.FC<ExportMenuProps> = ({ days = 30 }) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleExport = async (format: 'csv' | 'json') => {
    if (!user?.id) {
      message.error('Please log in to export data');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.get(
        `${config.apiUrl}/api/reports/export/${format}?days=${days}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob',
        },
      );

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `savings-report-${new Date().toISOString().split('T')[0]}.${format}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success(`Report exported as ${format.toUpperCase()}`);
    } catch (error: any) {
      console.error('Export failed:', error);
      message.error('Failed to export report');
    } finally {
      setLoading(false);
    }
  };

  const items: MenuProps['items'] = [
    {
      key: 'csv',
      label: 'Export as CSV',
      icon: <FileExcelOutlined />,
      onClick: () => handleExport('csv'),
    },
    {
      key: 'json',
      label: 'Export as JSON',
      icon: <FileTextOutlined />,
      onClick: () => handleExport('json'),
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Button
        icon={<DownloadOutlined />}
        loading={loading}
        type="default"
      >
        Export Report
      </Button>
    </Dropdown>
  );
};

